import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ThemeColor } from 'src/app/styleguide/models/theme.model';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./alert.component.scss'],
    imports: [NgClass]
})
export class AlertComponent {
  status = input<string>('danger');
  title = input<string>();
  message = input<string>();
}
